import React, { useRef, useEffect } from "react";
import Modal from "../../../components/Modal/Modal";
import { Colors } from "../../../utils/constants/style";
import { useStore } from "../../../store/useStore";
import { DocumentText } from "iconsax-react";
import Skeleton from "react-loading-skeleton";

interface PayrollPreviewModalProps {
  onClose: () => void;
  collaboratorId?: string;
}

const PayrollPreviewModal: React.FC<PayrollPreviewModalProps> = ({ onClose, collaboratorId }) => {
  const currentPayrollPreview = useStore(
    (state) => state.report.currentPayrollPreview
  );
  const selectedPayRoll = useStore(
    (state) => state.timeManager.selectedPayRoll
  );
  const isLoadingPreview = useStore(
    (state) => state.report.isLoadingPreview
  );

  const iframe_ref = useRef<HTMLIFrameElement>(null);
  let currentCollaborator;

  useEffect(() => {
    currentCollaborator = selectedPayRoll?.users?.find(
      (user) => user._id.toString() === collaboratorId?.toString()
    );
    const adjustIframeHeightAndZoom = () => {
      if (iframe_ref.current && iframe_ref.current.contentWindow) {
        const iframe_document = iframe_ref.current.contentWindow.document;
        const modal_width = window.innerWidth * 0.73;
        const scale = modal_width / 982;
        iframe_document.body.style.transform = `scale(${scale})`;
        iframe_document.body.style.transformOrigin = "top left";

        const contentHeight = iframe_document.documentElement.scrollHeight;
        iframe_ref.current.style.height = `${contentHeight}px`;
      }
    };
    if (iframe_ref.current) iframe_ref.current.addEventListener("load", adjustIframeHeightAndZoom);
    return () => {
      if (iframe_ref.current) iframe_ref.current.removeEventListener("load", adjustIframeHeightAndZoom);
    };
  }, [currentPayrollPreview, isLoadingPreview]);

  return (
    <Modal
      title="Visualização de folha de pagamento"
      icon={<DocumentText size={30} variant="Bold" color={Colors.white} />}
      className="w-[80%] min-h-[92%] flex flex-col"
      onClose={onClose}
    >
    {isLoadingPreview ? (
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <div className="w-[25%]">
            <Skeleton className="w-full h-[200px]" />
          </div>
          <div className="w-[73%]">
            <Skeleton className="w-full h-[200px]" />
          </div>
        </div>
        <Skeleton className="w-full h-[30px]" />
        {[...Array(15)].map((_, index) => (
          <Skeleton key={index} className="w-full h-[25px] -my-[7px]" />
        ))}
      </div>
    ) : currentPayrollPreview ? (
      <iframe
        ref={iframe_ref}
        srcDoc={currentPayrollPreview ?? ""}
        title="Payroll Preview"
        className="w-full border-none"
        style={{ height: "0px", overflow: "hidden" }}
      />
    ) : (
      <div className="flex flex-col items-center justify-center p-4">
        <span className="text-gray_03 text-md font-light mt-[300px]">
          Não há registros para a folha selecionada
        </span>
      </div>
    )}
    </Modal>
  );
};

export default PayrollPreviewModal;